import React, { useEffect, useState } from 'react'
import Datepicker from "react-tailwindcss-datepicker";
import Card from '../controls/Card';
import ContainerTwo from '../base/ContainerTwo';
import { useToast } from '../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import { GetAllByUser } from '../../configurations/crud/opdCentersCrud';
import { Dashboard } from '../../configurations/crud/reportCrud';
import moment from 'moment';
import StatusContainer from '../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../configurations/enums/ESource';
import { ETypeBg, GetETypeName } from '../../configurations/enums/EType';
import Getbalance from './rechargeHistory/Getbalance';
import { HiDocumentReport } from "react-icons/hi";
import Select from '../controls/Select';
import { FaClinicMedical } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";
import LoadingContainer from '../controls/LoadingContainer';
import useGlobalLoader from '../../configurations/useGlobalLoader';
import Empty from '../controls/Empty';

//const NEXT_MONTH = new Date();
//NEXT_MONTH.setMonth(NEXT_MONTH.getMonth() + 1);
const TODAY = new Date();

export default function DashBoard() {
    const { start, end } = useGlobalLoader()
    const [searchType, setSearchType] = useState(0);
    const [centerData, setCenterData] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(0);
    const initReport = {
        confirmedGlobal: [],
        confirmedSource: [],
        confirmedType: [],
        registeredGlobal: [],
    }
    const [reportData, setReportData] = useState(initReport);

    const toast = useToast()
    const [loding, setLoding] = useState(false)


    const [value, setValue] = useState({
        startDate: new Date(),
        endDate: TODAY
    });


    useEffect(() => {
        getReport()
        getAllOpdCenters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUser()
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    if (mdata.data.length > 0)
                        setCenterData(mdata.data);
                } else {
                    setCenterData([]);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setCenterData([]);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    function getReport() {
        setLoding(true);
        start()
        if (searchType == 1 && selectedCenter == 0) {
            toast.open("Please select center", <MdErrorOutline />, "danger")
            setLoding(false);
            return;
        }
        Dashboard({
            fromDate: moment(new Date(value.startDate)).format("MM/DD/YYYY"),
            toDate: moment(new Date(value.endDate)).format("MM/DD/YYYY"),
            centerId: searchType == 1 ? selectedCenter : 0,
            isCenter: searchType
        })
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    if (searchType == 0)
                        setReportData(mdata.global);
                    else
                        setReportData(mdata.center);
                } else {
                    setReportData(initReport);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setReportData(initReport);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)

            });
    }

    const doRefresh = () => {
        getReport()
        getAllOpdCenters();
    }

    return (
        <ContainerTwo>
            <Getbalance />

            {/*
              Filter is a plain card-styled container (NOT the <Card> component)
              so that overflow stays visible and the datepicker popover can
              extend beyond the box instead of being clipped.
            */}
            <div className="relative z-30 overflow-visible rounded-2xl border border-brand-300 bg-white p-4 shadow-sm">
                <div className="mb-3 flex items-center justify-between">
                    <h2 className="text-base font-semibold text-gray-800">DashBoard</h2>
                    <button
                        onClick={doRefresh}
                        title="Refresh"
                        className="grid h-8 w-8 place-items-center rounded-lg text-brand-600 transition hover:bg-gray-100 active:scale-95"
                    >
                        <FiRefreshCcw />
                    </button>
                </div>

                <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-end sm:gap-4">

                    {/* Type */}
                    <div className="w-full">
                        <label className="mb-1 block text-sm font-medium text-gray-700">Select</label>
                        <Select
                            Icon={<HiDocumentReport className="text-lg text-brand-600" />}
                            value={searchType}
                            onChange={(e) => setSearchType(Number(e.target.value))}
                        >
                            <option value={0}>All</option>
                            <option value={1}>Centers</option>
                        </Select>
                    </div>

                    {/* Center (conditional) */}
                    {searchType !== 0 && (
                        <div className="w-full">
                            <label className="mb-1 block text-sm font-medium text-gray-700">Select Center</label>
                            <Select
                                Icon={<FaClinicMedical className="text-lg text-red-600" />}
                                value={selectedCenter}
                                onChange={(e) => setSelectedCenter(e.target.value)}
                            >
                                <option value={0}>Select Center...</option>
                                {centerData.map(item => (
                                    <option key={item.id} value={item.id}>{item.centerName}</option>
                                ))}
                            </Select>
                        </div>
                    )}

                    {/* Date range */}
                    <div className="relative z-50 w-full">
                        <label className="mb-1 block text-sm font-medium text-gray-700">Date Range</label>
                        <Datepicker
                            popoverDirection="down"
                            displayFormat="DD/MM/YYYY"
                            readOnly={true}
                            separator="to"
                            primaryColor={"sky"}
                            value={value}
                            onChange={newValue => setValue(newValue)}
                            showShortcuts={true}
                            containerClassName="relative z-[100]"
                            inputClassName="bg-white border border-gray-200 text-gray-900 text-sm rounded-xl shadow-soft focus:ring-2 focus:ring-brand-400/30 focus:border-brand-400 w-full p-2.5 outline-none"
                        />
                    </div>

                    {/* Search */}
                    <button
                        onClick={getReport}
                        type="submit"
                        className="flex shrink-0 items-center justify-center gap-2 rounded-xl border border-brand-600 bg-brand-500 p-3 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus:ring-4 focus:ring-brand-300"
                    >
                        <svg className="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                        <span className="hidden sm:inline">Search</span>
                    </button>
                </div>
            </div>

            <div className="flex w-full items-center justify-center pt-8">
                {loding ? (
                    <div className="w-full">
                        <Card isBorder={true} borderColor="border-gray-400" title={"Report"}>
                            <LoadingContainer text="Please wait..." />
                        </Card>
                    </div>
                ) : (
                    <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2">

                        {/* All Registered */}
                        <Card isBorder={true} borderColor="border-green-400" title={"All Registered Patient"}>
                            <BarChart
                                data={reportData.registeredGlobal.map(i => ({
                                    label: <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} />,
                                    colorClass: ESourceBg(i.source),
                                    value: i.count,
                                }))}
                            />
                            <ReportTable
                                columns={[
                                    { header: "Source", render: (i) => <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} /> },
                                    { header: "Count", render: (i) => i.count },
                                ]}
                                rows={reportData.registeredGlobal}
                                total={reportData.registeredGlobal.reduce((sum, item) => sum + item.count, 0)}
                            />
                        </Card>

                        {/* All Confirmed */}
                        <Card isBorder={true} borderColor="border-green-400" title={"All Confirmed Patient"}>
                            <BarChart
                                data={reportData.confirmedGlobal.map(i => ({
                                    label: (
                                        <span className="flex flex-wrap items-center gap-1">
                                            <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} />
                                            <StatusContainer bg={ETypeBg(i.type)} text={GetETypeName(i.type)} />
                                        </span>
                                    ),
                                    colorClass: ESourceBg(i.source),
                                    value: i.count,
                                }))}
                            />
                            <ReportTable
                                columns={[
                                    { header: "Source", render: (i) => <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} /> },
                                    { header: "Type", render: (i) => <StatusContainer bg={ETypeBg(i.type)} text={GetETypeName(i.type)} /> },
                                    { header: "Count", render: (i) => i.count },
                                ]}
                                rows={reportData.confirmedGlobal}
                                total={reportData.confirmedGlobal.reduce((sum, item) => sum + item.count, 0)}
                            />
                        </Card>

                        {/* Confirmed by Source */}
                        <Card isBorder={true} borderColor="border-brand-300" title={"Confirmed Patient by Source"}>
                            <BarChart
                                data={reportData.confirmedSource.map(i => ({
                                    label: <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} />,
                                    colorClass: ESourceBg(i.source),
                                    value: i.count,
                                }))}
                            />
                            <ReportTable
                                columns={[
                                    { header: "Source", render: (i) => <StatusContainer bg={ESourceBg(i.source)} text={GetESourceName(i.source)} /> },
                                    { header: "Count", render: (i) => i.count },
                                ]}
                                rows={reportData.confirmedSource}
                                total={reportData.confirmedSource.reduce((sum, item) => sum + item.count, 0)}
                            />
                        </Card>

                        {/* Confirmed by Type */}
                        <Card isBorder={true} borderColor="border-brand-300" title={"Confirmed Patient by Type"}>
                            <BarChart
                                data={reportData.confirmedType.map(i => ({
                                    label: <StatusContainer bg={ETypeBg(i.type)} text={GetETypeName(i.type)} />,
                                    colorClass: ETypeBg(i.type),
                                    value: i.count,
                                }))}
                            />
                            <ReportTable
                                columns={[
                                    { header: "Type", render: (i) => <StatusContainer bg={ETypeBg(i.type)} text={GetETypeName(i.type)} /> },
                                    { header: "Count", render: (i) => i.count },
                                ]}
                                rows={reportData.confirmedType}
                                total={reportData.confirmedType.reduce((sum, item) => sum + item.count, 0)}
                            />
                        </Card>
                    </div>
                )}
            </div>
        </ContainerTwo>
    )
}

/* ---------- horizontal bar chart (zero-dependency) ---------- */
function BarChart({ data }) {
    if (!data || data.length === 0) return null
    const max = Math.max(...data.map(d => d.value), 1)
    const total = data.reduce((s, d) => s + d.value, 0)
    return (
        <div className="mb-4 space-y-3">
            {data.map((d, i) => {
                const pct = total ? Math.round((d.value / total) * 100) : 0
                return (
                    <div key={i}>
                        <div className="mb-1 flex items-center justify-between gap-2 text-xs">
                            <span className="min-w-0">{d.label}</span>
                            <span className="shrink-0 font-semibold text-gray-700">
                                {d.value}<span className="ml-1 font-normal text-gray-400">({pct}%)</span>
                            </span>
                        </div>
                        <div className="h-2.5 w-full overflow-hidden rounded-full bg-gray-100">
                            <div
                                className={`h-full rounded-full transition-[width] duration-500 ${d.colorClass}`}
                                style={{ width: `${(d.value / max) * 100}%` }}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

/* ---------- reusable report table ---------- */
function ReportTable({ columns, rows, total }) {
    return (
        <div className="overflow-x-auto rounded-xl ring-1 ring-gray-100">
            <table className="w-full border-collapse text-left text-sm text-gray-500">
                <thead>
                    <tr className="border-b border-gray-100 bg-slate-50 text-xs uppercase tracking-wide text-gray-500">
                        {columns.map((c, i) => (
                            <th key={i} scope="col" className="px-5 py-3 font-semibold">{c.header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                    {rows.length > 0 ? (
                        rows.map((item, ri) => (
                            <tr key={ri} className="bg-white hover:bg-gray-50">
                                {columns.map((c, ci) => (
                                    <td key={ci} className="px-5 py-2.5">{c.render(item)}</td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr className="bg-white">
                            <td colSpan={columns.length} className="px-3 py-2">
                                <Empty><div className="text-xl">No Items Found.</div></Empty>
                            </td>
                        </tr>
                    )}
                    <tr className="bg-gray-50 font-semibold text-gray-800">
                        <td className="px-5 py-2.5 text-right" colSpan={columns.length - 1}>Total:</td>
                        <td className="px-5 py-2.5 text-left">{total}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}